import { render } from "./SelectBrand.vue?vue&type=template&id=6fd4733a"
import script from "./SelectBrand.vue?vue&type=script&lang=ts"
export * from "./SelectBrand.vue?vue&type=script&lang=ts"
script.render = render

export default script